export const currencyFormat = (
  value: number | null | undefined,
  decimalCases: number = 2
) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: decimalCases
  }).format(value || 0);
